export const headers = [
  { field: "id", headerName: "ID", width: 24, hidden: true },
  { field: "tal_descripcion", headerName: "Descripcion", width: 230 },
  ];
  